import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {useSelector} from 'react-redux';
import {classify} from 'src/utils/classify';
import SenseLogo from 'src/images/sense-logo.svg';
import {selectBrand} from 'src/selectors/referral-external';
import {PanelHeader} from '@spaced-out/ui-design-system/lib/components/index';
import {LanguageSupport} from 'src/components/settings/language-support';

import css from 'src/components/referral-external/layout.css';


type Props = {
  children: React.ReactNode;
  isError: boolean;
  params: {
    referralLinkId: string;
    action: 'track' | 'success' | null | undefined | string;
    sourceEmail: string | null | undefined;
    uid: string | null | undefined;
    token: string | null | undefined;
    iframe?: boolean;
  };
};

export const Layout = ({children, isError, params}: Props) => {
  const brand = useSelector(selectBrand);
  const {t} = useLabelTranslation();

  return (
    <>
      {params.iframe && (
        <PanelHeader
          className={css.formHeader}
          onCloseButtonClick={() => {
            window.parent.postMessage(
              {
                type: 'CLOSE_REFER_NOW_PANEL',
                showReferNowPanel: false,
              },
              '*',
            );
          }}
        >
          {t('Refer_Now', 'Refer Now')}
        </PanelHeader>
      )}
      <div
        className={classify(css.container, {
          [css.errorLayoutContainer]: isError,
        })}
      >
        {!isError && brand.logo_url && <Logo logo={brand.logo_url} />}
        <LanguageSupport isExternalApp={true} />
        {children}
      </div>
    </>
  );
};

const Logo = ({logo, logoLink}: {logo?: string; logoLink?: string}) => {
  if (logo) {
    return logoLink ? (
      <a href={logoLink} rel="noopener noreferrer" target="_blank">
        <img className={css.logo} src={logo} />
      </a>
    ) : (
      <img className={css.logo} src={logo} />
    );
  }
  return (
    <a href="/" className={css.logo}>
      <SenseLogo />
    </a>
  );
};
